import React from 'react';
import { useObservable } from 'react-use-observable';

import { SummaryBar } from 'v2/components/Pages/Reports/SummaryBar';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import { affiliateCommissionsService } from 'v2/services/reports/affiliateCommissions';

import { ExportAffiliateComissions } from './Export';

export const Details = () => {
  const [totalItems] = useObservable(() => affiliateCommissionsService.getTotalItems(), []);
  const [totalGain] = useObservable(() => affiliateCommissionsService.getTotalGain(), []);
  const [isLoading] = useObservable(() => affiliateCommissionsService.isLoading(), []);

  const commissionsCount = `${totalItems} ${totalItems > 1 ? 'afiliados' : 'afiliado'}`;

  return (
    <SummaryBar
      countLabel={commissionsCount}
      totalLabel='Total das Comissões'
      totalValue={totalGain || 0}
      exportSlot={
        <PermissionHide action='myeduzz:reports:exportar'>{!isLoading && <ExportAffiliateComissions />}</PermissionHide>
      }
    />
  );
};
